import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PersonTypeEnum } from '@zaoblako/shared/modules/client/enums/person.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link PersonTypeEnum} enumeration values */
export const PersonTypeEnumI18n: EnumI18nInterface<PersonTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [PersonTypeEnum.LEGAL_ENTITY]: 'Юридическое лицо',
    [PersonTypeEnum.INDIVIDUAL_ENTREPRENEUR]: 'Индивидуальный предприниматель',
    [PersonTypeEnum.PRIVATE_CUSTOMER]: 'Физическое лицо',
    [PersonTypeEnum.SELF_EMPLOYED]: 'Самозанятый',
    [PersonTypeEnum.SEPARATE_DIVISION]: 'Обособленное подразделение',
    [PersonTypeEnum.GOVERNMENT_AGENCY]: 'Государственный орган',
  },
  [I18nLocalesEnum.EN_US]: {
    [PersonTypeEnum.LEGAL_ENTITY]: 'Legal Entity',
    [PersonTypeEnum.INDIVIDUAL_ENTREPRENEUR]: 'Individual Entrepreneur',
    [PersonTypeEnum.PRIVATE_CUSTOMER]: 'Private Customer',
    [PersonTypeEnum.SELF_EMPLOYED]: 'Self-employed',
    [PersonTypeEnum.SEPARATE_DIVISION]: 'Separate division',
    [PersonTypeEnum.GOVERNMENT_AGENCY]: 'Government agency',
  },
};
